<template>
    <div class="content-container">

        <SideBar class="side-menu"></SideBar>
        <div class="content">
            <router-view></router-view>
            <div class="footer">
                <div class="logo-eyecounter"><img src="@/assets/images/main/bottom-logo.png"></div>
                <div class="links">
                    <router-link :to="{name: 'help'}">{{$t('general.help')}}</router-link>
                    |
                    <router-link :to="{name: 'contact'}">{{$t('menu.contact')}}</router-link>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import SideBar from '@/components/SideBar.vue';

export default {
  name: 'Dashboard',
  components: { SideBar },
};
</script>

<style scoped lang="scss">
    .content-container {
        display: flex;
        margin-top: 76px;
        width: 100%;
        min-height: calc(100vh - 76px);
        @include media('<1025px') {
            position: relative;
        }
        @include media('<500px') {
            margin-top: 150px;
        }
    }

    .content {
        padding: 20px 50px 0 30px;
        box-sizing: border-box;
        width: calc(100% - 329px);
        @include media('<1025px') {
            width: 100%;
            padding: 50px 1.5rem 0 1.5rem;
        }
        display: flex;
        flex-direction: column;

        > div {
            width: 100%;
        }
    }

    .footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: auto;
        width: 100%;
        margin-bottom: 35px;
        padding-top: 35px;

        .logo-eyecounter {
            img {
                width: 100px;
                height: auto;
            }
        }

        .links {
            a {
                text-decoration: none;
                font-size: rem(18px);
            }
        }
    }

    .side-menu {

    }

    a {
        margin-left: 17px;
        text-decoration: none;
        color: #005fab;

        &:active, &:hover, &:visited {
            color: #005fab;
        }
    }
</style>
